import { EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type SupplierEvents = 'TABLE_NAME_CELL_CLICK' | 'EXPORT_SUPPLIER_RESULT';

export const supplier: Record<SupplierEvents, MixpanelEvent> = {
  TABLE_NAME_CELL_CLICK: {
    eventDescription: 'Click View Individual Supplier Details Page',
    eventKey: 'click-view-supplier-details-page',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  },
  EXPORT_SUPPLIER_RESULT: {
    eventDescription: 'Click quick export supplier',
    eventKey: 'click-quick-export-supplier',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.N_A
  }
} as const;
